export class SlideInfo {
    id: string;
    title: string;
    description: string;
    info: Array<any>;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/slide-info-model.ts